"use client";

import { Component, type ReactNode } from "react";
import { AlertTriangle } from "lucide-react";

import { t } from "@/lib/localization";
import { useLomdaLocale } from "../../hooks/useLomdaLocale";

function LoadError() {
    const locale = useLomdaLocale();
    return (
        <div className="flex items-center gap-2 rounded-xl border border-dashed border-destructive/40 bg-destructive/5 p-4 lomda-v3-text-small text-muted-foreground">
            <AlertTriangle className="size-4 shrink-0 text-destructive" />
            {t("lomda-v3-editor.block.load-error", locale)}
        </div>
    );
}

/**
 * Catches render errors from a single block so one bad/legacy block can't
 * white-screen the whole editor or player. Keyed by block id by the caller so
 * it re-mounts (and clears) when the block changes.
 */
export class BlockErrorBoundary extends Component<
    { children: ReactNode },
    { hasError: boolean }
> {
    state = { hasError: false };

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch() {
        // swallow — the fallback below is shown
    }

    render() {
        if (this.state.hasError) return <LoadError />;
        return this.props.children;
    }
}
